import Checkout from "../components/checkout/Checkout";
import Layout from "../layout/Layout";

const CheckoutPage = () => {
  return (
    <Layout>
      <Checkout />
    </Layout>
  );
};

export default CheckoutPage;
